export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"}],"link":[{"rel":"preconnect","href":"https://topauto.tn","crossorigin":""},{"rel":"dns-prefetch","href":"https://topauto.tn"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"preconnect","href":"https://app.spondei.com"},{"rel":"preconnect","href":"https://www.googletagmanager.com"},{"rel":"preconnect","href":"https://www.google-analytics.com"},{"rel":"dns-prefetch","href":"https://www.googletagmanager.com"},{"rel":"dns-prefetch","href":"https://www.google-analytics.com"},{"rel":"dns-prefetch","href":"https://fonts.gstatic.com"},{"rel":"preload","as":"font","type":"font/woff2","href":"https://fonts.gstatic.com/s/inter/v13/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hiA.woff2","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap","media":"print","onload":"this.media='all'"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&display=block&icon_names=add,add_2,all_inclusive,archive,arrow_back,arrow_forward,attach_file,auto_fix_high,auto_transmission,bookmark,bookmarks,brightness_auto,calendar_today,call,campaign,cancel,chat_bubble,check,check_circle,check_circle_outline,chevron_left,chevron_right,close,credit_card,dark_mode,delete,directions_car,download,edit,edit_square,error,expand_more,favorite,favorite_border,grid_view,help,help_outline,home,image,info,info_outline,key,language,light_mode,link,list,local_gas_station,local_offer,location_on,logout,mail,menu,mobile_2,mobile_3,monitor,more_horiz,notifications,open_with,paid,payments,person_add,phone,photo_camera,photo_library,place,progress_activity,receipt_long,reorder,replay,restore,road,rocket_launch,schedule,search,segment,sell,send,settings,share,sms,speed,star,star_border,store,storefront,swap_horiz,tablet_mac,trending_up,tune,verified,verified_user,visibility,warning,website,west,workspace_premium,zoom_in,zoom_out_map"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@24,400,0,0&display=block&icon_names=add,add_2,all_inclusive,archive,arrow_back,arrow_forward,attach_file,auto_fix_high,auto_transmission,bookmark,bookmarks,brightness_auto,calendar_today,call,campaign,cancel,chat_bubble,check,check_circle,check_circle_outline,chevron_left,chevron_right,close,credit_card,dark_mode,delete,directions_car,download,edit,edit_square,error,expand_more,favorite,favorite_border,grid_view,help,help_outline,home,image,info,info_outline,key,language,light_mode,link,list,local_gas_station,local_offer,location_on,logout,mail,menu,mobile_2,mobile_3,monitor,more_horiz,notifications,open_with,paid,payments,person_add,phone,photo_camera,photo_library,place,progress_activity,receipt_long,reorder,replay,restore,road,rocket_launch,schedule,search,segment,sell,send,settings,share,sms,speed,star,star_border,store,storefront,swap_horiz,tablet_mac,trending_up,tune,verified,verified_user,visibility,warning,website,west,workspace_premium,zoom_in,zoom_out_map"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Material+Icons+Outlined&display=block"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Material+Icons+Round&display=block"}],"style":[],"script":[{"id":"theme-init","tagPosition":"head","innerHTML":"(function(){try{var storageKey='theme';var legacyKey='theme-preference';var stored=localStorage.getItem(storageKey)||localStorage.getItem(legacyKey);var preference=(stored==='light'||stored==='dark'||stored==='system')?stored:'system';var prefersDark=window.matchMedia&&window.matchMedia('(prefers-color-scheme: dark)').matches;var resolved=preference==='system'?(prefersDark?'dark':'light'):preference;var root=document.documentElement;root.setAttribute('data-theme',resolved);root.style.colorScheme=resolved;}catch(e){}})();"},{},{"src":"https://www.googletagmanager.com/gtag/js?id=G-K7WG3034SR","async":true,"defer":true}],"noscript":[],"htmlAttrs":{"lang":"fr"},"__dangerouslyDisableSanitizersByTagID":{"theme-init":["innerHTML"]}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt","class":"isolate"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true